import { Col, Row } from 'react-bootstrap';
import { Control, Errors } from 'forms/rrf';
import TextInput from '../../../../common/form/elements/text-input';

const BandTarget = props => (
  <div>
    <Row>
      <Col md={2}>
        <h4>Band {props.line_number} target:</h4>
      </Col>
      <Col md={2}>
        <Control.input
          model={`deep.stock_it.levels.${props.id}.band_${props.line_number}_target_to`}
          type="number"
          min={0}
          defaultValue={props.target_to}
          validators={{
            maxValue: value => !value || value <= props.numberOfProducts
          }}
        />
      </Col>
      <Col md={2}>
        <h4>Points at band {props.line_number}</h4>
      </Col>
      <Col md={4}>
        <TextInput
          model={`deep.stock_it.levels.${props.id}.band_${props.line_number}_target_points`}
          placeholder='Enter the number of points to display at this banding'
          controlId={`pointsAtBand${props.line_number}`}
        />
      </Col>
    </Row>
    <Row>
      <Errors
        className="errors"
        model={`deep.stock_it.levels.${props.id}.band_${props.line_number}_target_to`}
        messages={{
          maxValue: `Target cannot be bigger than the number of products (${props.numberOfProducts})`
        }}
        show
        dynamic
      />
    </Row>
    <Row>
      <Errors
        className="errors"
        model={`deep.stock_it.levels.${props.id}.band_${props.line_number}_target_points`}
        show
        dynamic
      />
    </Row>
  </div>
);

export default BandTarget;
